import React, { Component } from "react";

export class Navigation extends Component {
  render() {
    return (
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container" style={{ width: "100%" }}>
          <div className="navbar-header" style={{ display: "flex", alignItems: "center" }}>
            <img
              src="img/FA.png"
              alt="FA Logo"
              style={{
                height: "80px",
                marginRight: "20px",
                marginTop: "0px"
              }}
            />
            <a className="navbar-brand page-scroll" href="#page-top">
              FA TAX & ACCOUNTING SOLUTIONS
            </a>
          </div>

          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="#services" className="page-scroll">
                  Services
                </a>
              </li>
              <li>
                <a href="#about" className="page-scroll">
                  About
                </a>
              </li>
              <li>
                <a href="#contact" className="page-scroll">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;
